import { mat4 } from 'gl-matrix';
export function getProjectionScaleMatrix(aspectRatio) {
    const [scaleX, scaleY] = aspectRatio;
    const projectionScaleMatrix = mat4.fromScaling(mat4.create(), [
        scaleX,
        scaleY,
        1.0,
    ]);
    return projectionScaleMatrix;
}
